<template>
  <!-- <pre v-if="responseData"> testData={{ kawalanDenggi }}</pre> -->
  <div v-if="responseData">
    <div class="content-wrapper">
      <h2>Program Kawalan Denggi</h2>
      <div class="input-row">
        <div class="input-item">
          <AppAutocomplete
            v-model="selectedMonth"
            label="Bulan"
            :items="months"
            placeholder="Pilih Bulan"
            chips
            class="app-date-picker"
          />
        </div> 
       

        <div class="input-item">
          <AppAutocomplete
            v-model="selectedYear"
            label="Tahun"
            :items="years"
            placeholder="Pilih Tahun"
            chips
            class="app-date-picker"
          />
        </div>

        <div class="input-item">
          <AppAutocomplete
            v-model="selectedsState"
            label="Negeri"
            :items="states"
            placeholder="Pilih Negeri"
            chips
            multiple
            closable-chips
            class="app-date-picker"
            @update:model-value="handleStateChange"
          />
        </div>

        <div class="input-item">
          <AppAutocomplete
            v-model="selectedPbt"
            label="Pihak Berkuasa Tempatan"
            :items="pbt"
            placeholder="Pilih PBT"
            class="app-date-picker"
            chips
            multiple
            closable-chips
            @update:model-value="handleStateChange"
          />
        </div>
      </div>

      
      <div class="dengue-control">
        <h2>AKTIVITI KAWALAN DENGGI</h2>

        <!-- Pemeriksaan Section -->
        <div class="pemeriksaan">
          <h4>Pemeriksaan</h4>
          <div class="activity-grid">
            <div
              v-for="item in dengueActivities.pemeriksaan"
              :key="item.title"
              class="activity-box"
            >
              <div class="box-overlay">
                <h3 class="box-title">
                  {{ item.title }}
                </h3>
                <p class="box-value">
                  {{ numberWithCommas(item.value) }}
                </p>
              </div>
              <img
                :src="item.image"
                class="responsive-image"
                alt="activity-image"
              >
            </div>
          </div>
        </div>

        <!-- Kawalan Section -->
        <div class="kawalan">
          <h4>Kawalan</h4>
          <div class="activity-grid">
            <div
              v-for="item in dengueActivities.kawalan"
              :key="item.title"
              class="activity-box"
            >
              <div class="box-overlay">
                <h3 class="box-title">
                  {{ item.title }}
                </h3>
                <p class="box-value">
                  {{ numberWithCommas(item.value) }}
                </p>
              </div>
              <img
                :src="item.image"
                class="responsive-image"
                alt="activity-image"
              >
            </div>
          </div>
        </div>

        <!-- Penguatkuasaan Section -->
        <div class="penguatkuasaan">
          <h4>Penguatkuasaan</h4>
          <div class="activity-grid">
            <div
              v-for="item in dengueActivities.penguatkuasaan"
              :key="item.title"
              class="activity-box"
            >
              <div class="box-overlay">
                <h3 class="box-title">
                  {{ item.title }}
                </h3>
                <p class="box-value">
                  {{ numberWithCommas(item.value) }}
                </p>
              </div>
              <img
                :src="item.image"
                class="responsive-image"
                alt="activity-image"
              >
            </div>
          </div>
        </div>

        <!-- Pendidikan Kesihatan Section -->
        <div class="pendidikan">
          <h4>Pendidikan Kesihatan</h4>
          <div class="activity-grid">
            <div
              v-for="item in dengueActivities.pendidikan"
              :key="item.title"
              class="activity-box"
            >
              <div class="box-overlay">
                <h3 class="box-title">
                  {{ item.title }}
                </h3>
                <p class="box-value">
                  {{ numberWithCommas(item.value) }}
                </p>
              </div>
              <img
                :src="item.image"
                class="responsive-image"
                alt="activity-image"
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <PrimaryModule />
    <KesihatanPersekitaran />
  </div>
</template>

<script setup>
import boxImage from '@/assets/spah/box.png'
import { useHttpService } from "@/httpService"
import { computed, onMounted, ref } from 'vue'

//added by abdullah 
definePage({
  alias: '/pages/pages/inspektorat/i-tegur',
  meta: {
    layout: 'blank',
    public: true,
  },
})

const years = ref([])

const months = ref([
  "Semua Bulan",  
  "Januari",
  "Februari",
  "Mac",
  "April",
  "Mei",
  "Jun", 
  "Julai",
  "Ogos",
  "September",
  "Oktober",
  "November",
  "Disember",
])


const states = ref(["Semua Negeri"])
const pbt = ref([])
const councils = ref([])
const selectedYear = ref(2025)

const selectedMonth = ref('Semua Bulan') 

// const selectedMonth = ref('Januari') 
const selectedsState = ref('Semua Negeri')
const selectedPbt = ref('Semua PBT')


const kawalanDenggi = ref({})



// Define activities dynamically
const dengueActivities = computed(() => ({
  pemeriksaan: [
    { title: "Premis Diperiksa", value: kawalanDenggi.value?.pemeriksaan_premis_diperiksa ?? 0, image: boxImage },
    { title: "Premis Positif", value: kawalanDenggi.value?.pemeriksaan_premis_positif ?? 0, image: boxImage },
    { title: "Bekas Diperiksa", value: kawalanDenggi.value?.pemeriksaan_bekas_diperiksa ?? 0, image: boxImage },
    { title: "Bekas Positif", value: kawalanDenggi.value?.pemeriksaan_bekas_positif ?? 0, image: boxImage },
  ],
  kawalan: [
    { title: "Semburan Kabus", value: kawalanDenggi.value?.kawalan_semburan_kabus ?? 0, image: boxImage },
    { title: "ULV", value: kawalanDenggi.value?.kawalan_ulv ?? 0, image: boxImage },
    { title: "Cari dan Musnah", value: kawalanDenggi.value?.kawalan_cari_musnah ?? 0, image: boxImage },
    { title: "Larvaciding", value: kawalanDenggi.value?.kawalan_larvaciding ?? 0, image: boxImage },
  ],
  penguatkuasaan: [
    { title: "Notis", value: kawalanDenggi.value?.penguatkuasaan_notis ?? 0, image: boxImage },
    { title: "Kompaun", value: kawalanDenggi.value?.penguatkuasaan_kompaun ?? 0, image: boxImage },
    { title: "Arahan Tutup", value: kawalanDenggi.value?.penguatkuasaan_arahan_tutup ?? 0, image: boxImage },
    { title: "Dakwa", value: kawalanDenggi.value?.penguatkuasaan_dakwa ?? 0, image: boxImage },
  ],
  pendidikan: [
    { title: "Gotong-royong", value: kawalanDenggi.value?.pendidikan_kesihatan_gotong_royong ?? 0, image: boxImage },
    { title: "Bilangan Kehadiran", value: kawalanDenggi.value?.pendidikan_kesihatan_peserta_hadir ?? 0, image: boxImage },
    { title: "Ceramah", value: kawalanDenggi.value?.pendidikan_kesihatan_ceramah ?? 0, image: boxImage },
    { title: "Pameran", value: kawalanDenggi.value?.pendidikan_kesihatan_pameran ?? 0, image: boxImage },
    { title: "Bahan Cetak / Risalah", value: kawalanDenggi.value?.pendidikan_kesihatan_bahan_cetak_risalah ?? 0, image: boxImage },
    { title: "Kempen", value: kawalanDenggi.value?.pendidikan_kempen ?? 0, image: boxImage },
    { title: "Media Elektronik", value: kawalanDenggi.value?.pendidikan_media ?? 0, image: boxImage },
  ],
}))

// Class mapping based on activity titles
const getClass = title => {
  const classMapping = {
    "Premis Diperiksa": "premis-diperiksa",
    "Premis Positif": "premis-positif",
    "Bekas Diperiksa": "bekas-diperiksa",
    "Bekas Positif": "bekas-positif",
    "Semburan Kabus": "semburan-kabus",
    "ULV": "ulv",
    "Cari dan Musnah": "cari-musnah",
    "Larvaciding": "larvaciding",
    "Notis": "notis",
    "Kompaun": "kompaun",
    "Arahan Tutup": "arahan-tutup",
    "Dakwa": "dakwa",
    "Gotong-royong": "gotong-royong",
    "Bilangan Kehadiran": "bilangan-kehadiran",
    "Ceramah": "ceramah",
    "Pameran": "pameran",
    "Bahan Cetak / Risalah": "bahan-cetak",
  }

  
  return classMapping[title] || ""
}

const { httpGet, numberWithCommas } = useHttpService()

const responseData = ref(null)
const overallData =  ref(null)




async function loadDataFromApi(month = selectedMonth.value, year = selectedYear.value, state = selectedsState.value, pbtValue = selectedPbt.value) {
  try {
    const plainStates = toRaw(state)
    let queryParams = `year=${year}`

    if (month === "Semua Bulan") {
      queryParams += `&month=all`
    } else {
      queryParams += `&month=${months.value.indexOf(month)}`
    }

    if (!plainStates.includes("Semua Negeri")) {
      if (Array.isArray(plainStates)) {
        plainStates.forEach(state => {
          const stateName = typeof state === "string" ? state : state.name || state.value
          if (stateName) {
            queryParams += `&states[]=${encodeURIComponent(stateName)}`
          }
        })
      } else {
        queryParams += `&states[]=${encodeURIComponent(plainStates)}`
      }
    }

    if (Array.isArray(pbtValue) && !pbtValue.includes('Semua PBT')) {
      pbtValue.forEach(pbt => {
        queryParams += `&councils[]=${encodeURIComponent(pbt)}`
      })
    }

    // ✅ Corrected: Removed duplicate year
    const url = `kesihatan-persekitaran/vektor/program-kawalan-denggi?${queryParams}`

    const response = await httpGet(url)

    years.value = response.years

    states.value = ["Semua Negeri"]
    response.states.forEach(state => {
      if (state && state !== "Modified Pbt") {
        states.value.push(state)
      }
    })

    councils.value = response.councils
    responseData.value = response
    kawalanDenggi.value = responseData.value.data.data 

  } catch (err) {
    console.error("loadDataFromApi failed:", err)
  }
}


function handleStateChange() {
  pbt.value = []

  // Ensure selectedsState and selectedPbt are arrays
  if (!Array.isArray(selectedsState.value)) {
    selectedsState.value = selectedsState.value ? [selectedsState.value] : []
  }
  if (!Array.isArray(selectedPbt.value)) {
    selectedPbt.value = selectedPbt.value ? [selectedPbt.value] : []
  }

  // Remove "Semua Negeri" if other states are selected
  if (selectedsState.value.includes("Semua Negeri") && selectedsState.value.length > 1) {
    selectedsState.value = selectedsState.value.filter(state => state !== "Semua Negeri")
  }

  // Remove "Semua PBT" if other PBTs are selected
  if (selectedPbt.value.includes("Semua PBT") && selectedPbt.value.length > 1) {
    selectedPbt.value = selectedPbt.value.filter(pbt => pbt !== "Semua PBT")
  }

  // If no states are selected, reset to "Semua Negeri"
  if (selectedsState.value.length === 0) {
    selectedsState.value = ["Semua Negeri"]
  }

  // If no PBTs are selected, reset to "Semua PBT"
  if (selectedPbt.value.length === 0) {
    selectedPbt.value = ["Semua PBT"]
  }

  if (selectedsState.value.includes("Semua Negeri")) {
    // Add all councils from all states
    Object.keys(councils.value).forEach(state => {
      if (councils.value[state] && typeof councils.value[state] === "object") {
        Object.keys(councils.value[state]).forEach(councilKey => {
          const council = councils.value[state][councilKey]
          if (council && council.value) {
            pbt.value.push(council.value)
          }
        })
      }
    })
  } else {
    // Only add councils for the selected states
    selectedsState.value.forEach(state => {
      if (councils.value[state] && typeof councils.value[state] === "object") {
        Object.keys(councils.value[state]).forEach(councilKey => {
          const council = councils.value[state][councilKey]
          if (council && council.value) {
            pbt.value.push(council.value)
          }
        })
      }
    })
  }

  console.log('Filtered PBT:', pbt.value)
}

onMounted(() => {
  loadDataFromApi()
  
})

//this is for setting the inital values for pbts as semua negeri id default option for Negeri (state) 
watch(councils, newValue => {
  if (newValue) handleStateChange()
}, { immediate: true })


watch([selectedMonth, selectedYear, selectedsState, selectedPbt], () => {
  loadDataFromApi(selectedMonth.value, selectedYear.value, selectedsState.value, selectedPbt.value)
}, { immediate: true })
</script>

<style scoped>
.image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-block-end: 20px;
}

h2 {
  color: rgb(21, 0, 105);
  font-size: 1.5rem;
  font-weight: bold;
  inline-size: 100%;
  margin-block: 40px 10px;
  text-align: left;
  text-transform: uppercase;
}


.pbt-image {
  block-size: auto;
  max-inline-size: 70%; /* Adjusted size */
}

.line-under-image {
  border-radius: 5px;
  background-color: white;
  block-size: 5px;
  inline-size: 70%; /* Match width to the image size */
  margin-block-start: 10px;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  padding: 20px;
  border-radius: 20px; /* Rounded corners */
  background-color: rgba(255, 255, 255, 65%); /* Background for content */
  box-shadow: 0 4px 15px rgba(0, 0, 0, 20%); /* Shadow for depth */
  inline-size: 100%;
  margin-block: 20px;
  margin-inline: 0;
  max-inline-size: 1200px;
}


h4 {
  color: rgb(17, 6, 65);
  font-size: 1.2rem; 
  font-weight: bold;
  margin-bottom: 10px; 
  text-align: left; 
  width: 100%;
}

/* Flexbox container for the input fields */
.input-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

/* Styles for each input field */
.input-item {
  flex: 1;
  margin-right: 15px;
}


.input-item:last-child {
  margin-right: 0;
}


.pemeriksaan, .kawalan, .penguatkuasaan, .pendidikan {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  width: 100%;
  max-width: 1200px;
  padding: 20px;
  border-radius: 15px;
  margin-bottom: 20px;
  background-color: rgba(255, 255, 255, 0.85);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  margin-top: 0; /* Set top margin to 0 to eliminate the gap */
}

.activity-box {
  position: relative;
  display: inline-block;
  width: 100%;
  height: auto;
  border-radius: 10px;
  overflow: hidden;
}

.responsive-image {
  width: 100%;
  height: auto;
  display: block;
}

.box-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white;
}

.box-title {
  font-size: 1.2rem;
  font-weight: bold;
  color: #150069;
}

.box-value {
  font-size: 1.5rem;
  font-weight: bold;
  color: #a80000;
}

.activity-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr); /* This ensures 4 equal-width boxes */
  gap: 30px; /* Adjust the spacing between the boxes */
}

.text-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-family: Arial, sans-serif;
  text-align: center; /* Centers the text horizontally */
}

.values-layered h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #150069;
  text-align: center;
}

.number {
  font-size: 24px;
  font-weight: bold;
  color: #a80000;
  text-align: center;
}


.chart-wrapper {
  padding: 20px;
  border-radius: 10px;
  background: rgba(255, 254, 254, 80%);
  inline-size: 100%;
  max-inline-size: 1400px;
  margin-top: 40px;
}
</style>
